/* Ardor Flag Designer: flag shape and size, sides and pole side, pole kit, carry bag, quantity, delivery, live price,
artwork layout (rotate in 90 degree steps, zoom and pan for tall flags), 3D preview, proof approval, cart and quote.
Ardor Printing. New Oct 11, 2026. v2 = assets/ardor-flag-builder-v2.js (Oct 12, 2026, patch list tpl/flagfam/flag-builder.patch
on an unchanged copy of ardor-flag-builder.js): a finished template upload (the shape of the template page, within 1%) is
placed edge to edge (tplFit); the add-to-cart upload stays under the cart's 20 MB limit (fitUpload); tplInfo() names the
product for the template download (assets/ardor-flag-tpl.js).
Made from a copy of ardor-yardsign-builder.js (unchanged) by the patch list
core/builder.patch (flag build folder). Loaded by sections/ardor-flag-builder-ws.liquid.
Every flag is drawn at true proportions from its print template (window.ArdorFlagShapes, assets/ardor-flag-shapes.js):
template page, cut line, pole sleeve and safe line. The editor and the print files use the template page in inches.
Works with ardor-flag-layers.js (text and clipart), ardor-flag-ai.js (AI design), ardor-flag3d.js (3D view) and
ardor-flag-pdf.js (proof and print PDFs). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- flags, sides, pole kits and prices ----------
  // One Shopify variant per flag, sides and kit (product "Custom Flags", options Flag / Sides / Kit). The section writes
  // every variant into the config: k = SKU ("FL-<KEY>-<1S|2S>-<KIT>"), f = Flag option, d = Sides option, t = Kit option,
  // id, c = price of ONE flag in cents, a = available. The cart line quantity is the number of flags.
  // Carry bags are the hidden product "flag-carry-bag", one variant per flag (SKU "FL-BAG-<KEY>"), added as a second
  // cart line with the same quantity. "Pole side" (1 side only) is a line item property: both sides cost the same.
  // FALLBACK (window.ArdorFlagShapes.fallback, cents per flag) is only used when the config has no variants, so a price
  // always shows; Add to cart then asks the customer to call.
  var SHAPES = window.ArdorFlagShapes || {};
  var SH = SHAPES.flags || {};
  var FALLBACK = SHAPES.fallback || {};
  var GROUPS = [
    { id: 'FA', name: 'Feather flag, angled', short: 'angled feather flag', shape: 'feather-angled' },
    { id: 'FC', name: 'Feather flag, convex', short: 'convex feather flag', shape: 'feather-convex' },
    { id: 'TD', name: 'Teardrop flag', short: 'teardrop flag', shape: 'teardrop' },
    { id: 'RC', name: 'Rectangle flag', short: 'rectangle flag', shape: 'rectangle' },
    { id: 'PF', name: 'Pole flag', short: 'pole flag', shape: 'pole-flag' }
  ];
  // key, shape group, size name, height in feet (0 = sized by the flag itself)
  var FLAG_LIST = [
    ['FA-S', 'FA', 'Small', 9], ['FA-M', 'FA', 'Medium', 10.5], ['FA-L', 'FA', 'Large', 14], ['FA-XL', 'FA', 'XL', 18],
    ['FC-S', 'FC', 'Small', 9], ['FC-M', 'FC', 'Medium', 10.5], ['FC-L', 'FC', 'Large', 14], ['FC-XL', 'FC', 'XL', 18],
    ['FE-16', 'FC', 'Econo', 16],
    ['TD-S', 'TD', 'Small', 7], ['TD-M', 'TD', 'Medium', 9], ['TD-L', 'TD', 'Large', 11.2], ['TD-XL', 'TD', 'XL', 13.5],
    ['TD-DESK', 'TD', 'Desktop', 0],
    ['RC-S', 'RC', 'Small', 8.5], ['RC-M', 'RC', 'Medium', 11.8], ['RC-L', 'RC', 'Large', 15],
    ['PF-3x2', 'PF', '3 x 2 ft', 0], ['PF-5x3', 'PF', '5 x 3 ft', 0], ['PF-6x4', 'PF', '6 x 4 ft', 0]
  ];
  var KITS = [
    { id: 'none', name: 'Flag only', sub: 'For poles you already have', short: 'flag only', k3d: 'none' },
    { id: 'ground-stake', name: 'Pole + ground stake', sub: 'For grass and dirt', short: 'pole and ground stake', k3d: 'ground-stake' },
    { id: 'cross-base', name: 'Pole + cross base', sub: 'For pavement and indoors', short: 'pole and cross base', k3d: 'cross-base' },
    { id: 'cross-water', name: 'Pole + cross base + water bag', sub: 'Extra weight on hard surfaces', short: 'pole, cross base and water bag', k3d: 'cross-water' },
    { id: 'square-base', name: 'Pole + square base', sub: 'Heavy steel base for hard surfaces', short: 'pole and square base', k3d: 'square-base' },
    { id: 'cross-ground', name: 'Pole + cross base + ground stake', sub: 'For grass, dirt or pavement', short: 'pole, cross base and ground stake', k3d: 'cross-base' },
    { id: 'pole-only', name: 'Flag + pole', sub: 'Pole only, no wall bracket', short: 'pole', k3d: 'none' },
    { id: 'pole-bracket', name: 'Pole + wall bracket', sub: 'Mounts on a wall or post', short: 'pole and wall bracket', k3d: 'none' },
    { id: 'desktop-base', name: 'Desktop pole + base', sub: 'For a table or counter', short: 'desktop pole and base', k3d: 'cross-base' }
  ];
  var MAX_QTY = 100;
  var SAFE = 2; // inches inside the cut line for the dashed red safe line when the template gives none
  var MAX_FILE = 25 * 1024 * 1024;
  var PICKUP = CONF.pickup || '12531 Old Snohomish Monroe Rd., Snohomish, WA 98290';

  var FLAG_BY = {};
  var FLAGS = FLAG_LIST.map(function (r) {
    var g = groupOf(r[1]);
    var f = { key: r[0], group: r[1], size: r[2], ft: r[3], shape: r[0] === 'FE-16' ? 'feather-econo' : (r[0] === 'TD-DESK' ? 'teardrop-desk' : g.shape) };
    FLAG_BY[f.key] = f;
    return f;
  });
  function groupOf(id) { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].id === id) return GROUPS[i]; return GROUPS[0]; }
  function kitOf(id) { for (var i = 0; i < KITS.length; i++) if (KITS[i].id === id) return KITS[i]; return KITS[0]; }
  function normKey(s) { s = String(s || '').trim().toUpperCase().replace(/(\d)X(\d)/, '$1x$2'); return FLAG_BY[s] ? s : ''; }
  // the kit of a variant, from the Kit option text ("Pole + cross base + water bag" ...)
  function kitId(t) {
    var s = String(t || '').toLowerCase();
    if (/desk/.test(s)) return 'desktop-base';
    if (/bracket|wall/.test(s)) return 'pole-bracket';
    if (/water/.test(s)) return 'cross-water';
    if (/cross/.test(s)) return /stake|ground|spike/.test(s) ? 'cross-ground' : 'cross-base';
    if (/square|plate/.test(s)) return 'square-base';
    if (/stake|ground|spike/.test(s)) return 'ground-stake';
    if (/flag only|^none$|no pole/.test(s)) return 'none';
    if (/pole/.test(s)) return 'pole-only';
    if (/only/.test(s)) return 'none';
    return '';
  }
  // the flag of a variant: from its SKU (FL-<KEY>-...), else from the Flag option text
  function keyFromText(t) {
    var s = String(t || '').toLowerCase(), m = /(\d)\s*(?:x|×)\s*(\d)/.exec(s);
    if (/pole/.test(s) && m) return normKey('PF-' + m[1] + 'x' + m[2]);
    if (/desk/.test(s)) return 'TD-DESK';
    if (/econo/.test(s)) return 'FE-16';
    var grp = /tear/.test(s) ? 'TD' : (/rect/.test(s) ? 'RC' : (/convex|round/.test(s) ? 'FC' : (/feather|angled/.test(s) ? 'FA' : '')));
    var sz = /\bxl\b|x-large|extra/.test(s) ? 'XL' : (/small/.test(s) ? 'S' : (/medium/.test(s) ? 'M' : (/large/.test(s) ? 'L' : '')));
    return grp && sz ? normKey(grp + '-' + sz) : '';
  }
  function keyOf(v) {
    var m = /^FL-(.+?)-(1S|2S)(?:-|$)/i.exec(String(v.k || ''));
    return (m && normKey(m[1])) || keyFromText(v.f);
  }
  function fallbackCents(key, d, kit) { var f = FALLBACK[key]; var x = f && f[d === 2 ? '2' : '1']; return (x && Math.round(Number(x[kit]))) || 0; }
  var VAR = {}, HAS = {}, LIVE = false;
  CONF.variants.forEach(function (v) {
    if (!v) return;
    var key = keyOf(v), d = parseInt(String(v.d || ''), 10), kit = kitId(v.t);
    if (!key || !(d === 1 || d === 2) || !kit) return;
    var p = Math.round(Number(v.c));
    VAR[key + '|' + d + '|' + kit] = { id: v.id || null, cents: isFinite(p) && p > 0 ? p : fallbackCents(key, d, kit), available: v.a !== false };
    HAS[key] = true; LIVE = true;
  });
  // the variant for a flag, sides and kit. none = the product has no such variant (that kit is not offered for it)
  function variantFor(key, d, kit) {
    var v = VAR[key + '|' + d + '|' + kit];
    if (v) return v;
    if (LIVE) return { id: null, cents: 0, available: false, none: true };
    var x = fallbackCents(key, d, kit);
    return { id: null, cents: x, available: false, none: !x };
  }
  // carry bags: one variant per flag on the "flag-carry-bag" product
  var BAG = {};
  (CONF.bags || []).forEach(function (b) {
    if (!b || !b.id) return;
    var m = /^FL-BAG-(.+)$/i.exec(String(b.k || '')), key = (m && normKey(m[1])) || keyFromText(b.t);
    var p = Math.round(Number(b.c));
    if (key && isFinite(p) && p > 0) BAG[key] = { id: b.id, cents: p, available: b.a !== false };
  });
  function bagFor(key) { var b = BAG[key]; return b && b.available ? b : null; }
  function kitsFor(key, d) { return KITS.filter(function (k) { return !variantFor(key, d, k.id).none; }); }
  function flagsShown() { return FLAGS.filter(function (f) { return LIVE ? !!HAS[f.key] : !!FALLBACK[f.key]; }); }
  function groupsShown() { var fl = flagsShown(); return GROUPS.filter(function (g) { return fl.some(function (f) { return f.group === g.id; }); }); }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  // ---------- print template geometry ----------
  // Inches from the template page's top-left. Each flag has up to three templates: "ss" (1 side, pole sleeve on the left
  // as seen from the front), "ssr" (1 side, sleeve on the right) and "ds" (2 sides: one page with the front on the left
  // half and the back, as seen from the back, on the right half). The editor shows ONE face on its own page: for "ds" the
  // half of the page that face sits on. Missing templates are mirrored from the ones there.
  var GEO = {};
  function pts(p) { return (p || []).map(function (q) { return q && q.length ? [+q[0], +q[1]] : [+q.x, +q.y]; }).filter(function (q) { return isFinite(q[0]) && isFinite(q[1]); }); }
  function polys(p) { if (!p || !p.length) return []; return (p[0] && typeof p[0][0] === 'number') || (p[0] && p[0].x != null) ? [pts(p)] : p.map(pts).filter(function (x) { return x.length > 2; }); }
  function bbox(p) { var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9; p.forEach(function (q) { x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); x1 = Math.max(x1, q[0]); y1 = Math.max(y1, q[1]); }); return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 }; }
  function mirPts(p, W) { return p.map(function (q) { return [W - q[0], q[1]]; }); }
  function shiftPts(p, dx) { return p.map(function (q) { return [q[0] + dx, q[1]]; }); }
  function area(p) { var a = 0; for (var i = 0, j = p.length - 1; i < p.length; j = i++) a += p[j][0] * p[i][1] - p[i][0] * p[j][1]; return a / 2; }
  // the outline moved d inches inward (mitered corners, capped so sharp tips do not spike)
  function inset(p, d) {
    var n = p.length, out = [], s = area(p) > 0 ? 1 : -1;
    for (var i = 0; i < n; i++) {
      var a = p[(i - 1 + n) % n], b = p[i], c = p[(i + 1) % n];
      var e1x = b[0] - a[0], e1y = b[1] - a[1], e2x = c[0] - b[0], e2y = c[1] - b[1];
      var l1 = Math.hypot(e1x, e1y) || 1, l2 = Math.hypot(e2x, e2y) || 1;
      var n1x = -s * e1y / l1, n1y = s * e1x / l1, n2x = -s * e2y / l2, n2y = s * e2x / l2;
      var k = 1 + n1x * n2x + n1y * n2y, f = k > 0.25 ? d / k : d * 4;
      out.push([b[0] + (n1x + n2x) * f, b[1] + (n1y + n2y) * f]);
    }
    return out;
  }
  // keep the part of a polygon with x >= x0 (dir 1) or x <= x0 (dir -1)
  function clipX(p, x0, dir) {
    var out = [], n = p.length, inside = function (q) { return (q[0] - x0) * dir >= 0; };
    for (var i = 0; i < n; i++) {
      var a = p[i], b = p[(i + 1) % n], ia = inside(a), ib = inside(b);
      if (ia) out.push(a);
      if (ia !== ib) { var t = (x0 - a[0]) / (b[0] - a[0]); out.push([x0, a[1] + (b[1] - a[1]) * t]); }
    }
    return out;
  }
  // one template ("ss", "ssr" or "ds") as stored: { page:[w,h], cut, sleeve, safe, cutBack, sleeveBack, safeBack, sleeveW, face, name }
  function tpl(key, id) { var f = SH[key]; var t = f && f.t && f.t[id]; return t && t.page && t.cut && t.cut.length > 2 ? t : null; }
  function faceFrom(t, back, half) {
    var W = +t.page[0], H = +t.page[1], dx = 0;
    var cut = pts(back ? t.cutBack : t.cut), sleeve = polys(back ? t.sleeveBack : t.sleeve), safe = polys(back ? t.safeBack : t.safe);
    if (half) { var sp = +t.split || W / 2; if (back) { dx = -sp; W = W - sp; cut = shiftPts(cut, dx); sleeve = sleeve.map(function (q) { return shiftPts(q, dx); }); safe = safe.map(function (q) { return shiftPts(q, dx); }); } else W = sp; }
    var side = back ? (t.backSleeveSide || 'right') : (t.sleeveSide || 'left');
    return { W: W, H: H, cut: cut, sleeve: sleeve, safe: safe, side: side, sleeveW: +t.sleeveW || 0, safeIn: +t.safeIn || 0, name: t.name || '' };
  }
  function mirrorFace(g) {
    var W = g.W;
    return { W: W, H: g.H, cut: mirPts(g.cut, W), sleeve: g.sleeve.map(function (q) { return mirPts(q, W); }), safe: g.safe.map(function (q) { return mirPts(q, W); }), side: g.side === 'left' ? 'right' : 'left', sleeveW: g.sleeveW, safeIn: g.safeIn, name: g.name, mirrored: true };
  }
  // a placeholder when the shapes file has nothing for a flag: a plain rectangle the size of the published graphic
  function plainFace(key) {
    var f = SH[key] || {}, gi = f.graphic || [30, 120], w = +gi[0] || 30, h = +gi[1] || 120, b = 0.5;
    var W = w + 2 * b, H = h + 2 * b;
    return { W: W, H: H, cut: [[b, b], [b + w, b], [b + w, b + h], [b, b + h]], sleeve: [], safe: [], side: 'left', sleeveW: 0, safeIn: 0, name: '', placeholder: true };
  }
  // finish a face: the pole sleeve, the safe line, the printable face box and the cut line's box. The black sleeve is
  // sewn on along the pole edge and is not printed: it is drawn as a band just outside the cut line on the pole side.
  // The safe line is the template's own inset ("keep important text 2 in from the edge", 1 in on the desktop flag).
  // the part of the cut line the sleeve is sewn along: from the bottom of the pole edge, up and over the top
  function sleeveRun(cut, side) {
    var bb = bbox(cut), edge = side === 'left' ? bb.x : bb.x + bb.w, near = Math.max(0.6, bb.w * 0.04), n = cut.length, s = -1, i;
    var onEdge = function (q) { return Math.abs(q[0] - edge) <= near; };
    for (i = 0; i < n; i++) if (onEdge(cut[i]) && (s < 0 || cut[i][1] > cut[s][1])) s = i;
    if (s < 0) return null;
    var a = cut[(s + 1) % n], b = cut[(s - 1 + n) % n];
    var dir = onEdge(a) && (!onEdge(b) || a[1] <= b[1]) ? 1 : -1;
    var run = [cut[s]], minY = cut[s][1], j = s;
    for (var k = 1; k < n; k++) {
      j = (j + dir + n) % n;
      if (cut[j][1] > minY + 0.5 && run.length > 2) break;
      run.push(cut[j]); if (cut[j][1] < minY) minY = cut[j][1];
    }
    return run.length > 1 ? run : null;
  }
  function finish(g, key) {
    var bb = bbox(g.cut), f = FLAG_BY[key];
    if (!g.sleeve.length && f && f.group !== 'PF') {
      var sw = Math.min(1.25, Math.max(0.5, bb.w * 0.05)), edge = g.side === 'left' ? bb.x : bb.x + bb.w, near = Math.max(0.6, bb.w * 0.04);
      var ys = g.cut.filter(function (q) { return Math.abs(q[0] - edge) <= near; }).map(function (q) { return q[1]; });
      var y0 = ys.length ? Math.min.apply(null, ys) : bb.y, y1 = ys.length ? Math.max.apply(null, ys) : bb.y + bb.h;
      var x0 = g.side === 'left' ? edge - sw : edge;
      g.sleeve = [[[x0, y0], [x0 + sw, y0], [x0 + sw, y1], [x0, y1]]];
      g.sleeveOut = true; g.sleeveW = sw;
      g.run = sleeveRun(g.cut, g.side);
    }
    var m = 0.25;
    g.face = [Math.max(0, bb.x - m), Math.max(0, bb.y - m), Math.min(g.W, bb.x + bb.w + m), Math.min(g.H, bb.y + bb.h + m)];
    if (!g.safe.length) { var s = inset(g.cut, g.safeIn || SAFE); g.safe = s.length > 2 ? [s] : []; }
    g.bx = bb.x; g.by = bb.y; g.bw = bb.w; g.bh = bb.h;
    return g;
  }
  // which: 'ss' | 'ssr' | 'dsf' (2 sides, front) | 'dsb' (2 sides, back as seen from the back)
  function geoFor(key, which) {
    var id = key + '|' + which;
    if (GEO[id]) return GEO[id];
    var ss = tpl(key, 'ss'), ssr = tpl(key, 'ssr'), ds = tpl(key, 'ds'), g = null;
    if (which === 'ss') g = ss ? faceFrom(ss) : (ssr ? mirrorFace(faceFrom(ssr)) : (ds ? faceFrom(ds, false, true) : null));
    else if (which === 'ssr') g = ssr ? faceFrom(ssr) : (ss ? mirrorFace(faceFrom(ss)) : (ds && ds.cutBack ? faceFrom(ds, true, true) : null));
    else if (which === 'dsf') g = ds ? faceFrom(ds, false, true) : (ss ? faceFrom(ss) : null);
    else g = ds && ds.cutBack ? faceFrom(ds, true, true) : (ssr ? faceFrom(ssr) : (ss ? mirrorFace(faceFrom(ss)) : null));
    if (!g) { g = plainFace(key); if (which === 'ssr' || which === 'dsb') g = mirrorFace(g); }
    g.tplName = (which === 'ss' ? (ss && ss.name) : which === 'ssr' ? (ssr && ssr.name) : (ds && ds.name)) || '';
    g.placeholder = !!(g.placeholder || (SH[key] && SH[key].placeholder));
    return (GEO[id] = finish(g, key));
  }
  // the face being shown or printed: front, or the back of a 2-sided flag
  function faceGeo(c, face) {
    var back = face === 'back' || face === 'back-flat';
    if (c.sides === 2) return geoFor(c.key, back ? 'dsb' : 'dsf');
    return geoFor(c.key, c.pole === 'right' ? 'ssr' : 'ss');
  }

  var S = { key: '', sides: 1, pole: 'left', kit: 'ground-stake', bag: false, qty: 1, delivery: 'ship', back: false, backMode: 'same', face: 'front', artVer: 0 };
  var ART = { front: null, back: null };
  var eng = null;
  (function () {
    var fl = flagsShown(), want = normKey(CONF.defaultFlag) || 'FA-M';
    S.key = (fl.filter(function (f) { return f.key === want; })[0] || fl[0] || FLAGS[1]).key;
  })();

  // c.Wi x c.Hi = the template page of the face in inches (art covers all of it, bleed included). c.qty = flags.
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var f = FLAG_BY[s.key] || flagsShown()[0] || FLAGS[1];
    var sides = Number(s.sides) === 2 ? 2 : 1;
    if (!kitsFor(f.key, sides).length) sides = sides === 2 ? 1 : 2;
    var kits = kitsFor(f.key, sides), kit = kits.filter(function (k) { return k.id === s.kit; })[0] || kits.filter(function (k) { return k.id !== 'none'; })[0] || kits[0] || KITS[0];
    // the pole side is a choice on 1-sided feather, teardrop and rectangle flags (pole flags and the desktop flag have one)
    var poleOk = f.group !== 'PF' && f.key !== 'TD-DESK';
    var bagV = bagFor(f.key), pole = sides === 1 && poleOk && s.pole === 'right' ? 'right' : 'left';
    var qty = Math.max(1, Math.min(MAX_QTY, Math.round(Number(s.qty)) || 1));
    var c = { key: f.key, flag: f, group: groupOf(f.group), sides: sides, pole: pole, poleOk: poleOk, kit: kit.id, kitObj: kit, kits: kits, bag: !!s.bag && !!bagV, bagV: bagV, qty: qty,
      delivery: s.delivery === 'pickup' ? 'pickup' : 'ship', v: variantFor(f.key, sides, kit.id), artVer: s.artVer };
    c.geo = faceGeo(c, 'front'); c.Wi = c.geo.W; c.Hi = c.geo.H;
    return c;
  }
  // each = one flag with its kit; flags = all flags; bags = all carry bags; charged = what goes in the cart
  function price(c) {
    var each = c.v.cents / 100, bagEach = c.bagV ? c.bagV.cents / 100 : 0;
    var flags = each * c.qty, bags = c.bag ? bagEach * c.qty : 0;
    return { each: each, flags: flags, bagEach: bagEach, bags: bags, charged: flags + bags, unit: each, vid: c.v.id, disc: 0 };
  }
  // the lowest price a flag (or a whole shape) can be ordered for
  function fromCents(key) {
    var lo = 0;
    [1, 2].forEach(function (d) { KITS.forEach(function (k) { var v = variantFor(key, d, k.id); if (!v.none && v.cents > 0 && (!lo || v.cents < lo)) lo = v.cents; }); });
    return lo;
  }
  function groupFrom(gid) { var lo = 0; flagsShown().forEach(function (f) { if (f.group !== gid) return; var x = fromCents(f.key); if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }
  // the kit to show a flag's price with: the chosen kit when that flag has it, else its first one
  function kitPick(key, d, kit) { var ks = kitsFor(key, d); return (ks.filter(function (k) { return k.id === kit; })[0] || ks.filter(function (k) { return k.id !== 'none'; })[0] || ks[0] || KITS[0]).id; }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function sizeName(f) { return f.group === 'PF' ? f.size : (f.key === 'TD-DESK' ? 'Desktop' : (f.key === 'FE-16' ? 'Econo 16 ft' : f.size + ' ' + fmt(f.ft) + ' ft')); }
  // the published graphic size (finished flag) when the specs have it, else the cut line's box
  function graphicTxt(g, key) { var gi = key && SH[key] && SH[key].graphic, w = gi ? +gi[0] : g.bw, h = gi ? +gi[1] : g.bh; return fmt(Math.round(w * 4) / 4) + ' x ' + fmt(Math.round(h * 4) / 4) + ' in'; }
  function sizeSub(f, g) {
    if (f.group === 'PF') return graphicTxt(g, f.key) + ' flag (width x height)';
    if (f.key === 'TD-DESK') return 'For a table or counter, ' + graphicTxt(g, f.key) + ' flag';
    return fmt(f.ft) + ' ft tall, ' + graphicTxt(g, f.key) + ' flag';
  }
  function flagLabel(c) { return c.group.name + (c.flag.key === 'FE-16' ? ' (econo)' : (c.flag.key === 'TD-DESK' ? ' (desktop)' : '')); }
  function sizeLabel(c) { return sizeName(c.flag) + ', ' + graphicTxt(c.geo, c.key) + ' flag'; }
  function sizeChip(c) { return c.flag.group === 'PF' ? 'Pole flag ' + c.flag.size : (c.flag.key === 'TD-DESK' ? 'Desktop teardrop flag' : sizeName(c.flag) + ' ' + c.group.short); }
  function sidesLabel(c) { return c.sides === 2 ? '2 sides (double-sided)' : '1 side (printed through)'; }
  function poleLabel(c) { return c.pole === 'right' ? 'Right' : 'Left'; }
  function kitLabel(c) { return c.kitObj.name; }
  function qtyLabel(n) { return n + (n === 1 ? ' flag' : ' flags'); }
  function bagCount(n) { return n + ' carry bag' + (n === 1 ? '' : 's'); }
  function bagLabel(c) { return c.bag ? 'Yes, ' + bagCount(c.qty) + ', one per flag' : 'No'; }
  function deliveryLabel(c) { return c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Ship to me (free)'; }
  function frontLabel(c) { return c.sides === 2 && S.backMode !== 'different' ? 'Front (same art on the back)' : 'Front'; }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new flag: keep the art, but fit it to the new flag (Fill for pictures, Fit for files), and show the whole flag
  function resetArt() { [ART.front, ART.back].forEach(function (a) { if (a) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } }); }
  function pickFlag(key) {
    if (key === S.key) return;
    resetArt(); lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5;
    set({ key: key, artVer: S.artVer + 1 });
  }
  // a new shape: the same size name in that shape when there is one, else its middle size
  function pickGroup(gid) {
    var c = cfg(); if (c.flag.group === gid) return;
    var fl = flagsShown().filter(function (f) { return f.group === gid; }); if (!fl.length) return;
    var same = fl.filter(function (f) { return f.size === c.flag.size; })[0];
    pickFlag((same || fl[Math.min(fl.length - 1, 1)]).key);
  }
  function pickSides(n) {
    if (n === cfg().sides) return;
    var patch = { sides: n, artVer: S.artVer + 1 };
    if (n === 1) { patch.face = 'front'; patch.back = false; }
    set(patch);
    if (n === 1) view3d('front');
  }
  // 1 side: the pole sleeve on the left or the right (as seen from the front). Same price.
  function pickPole(p) { if (p === S.pole) return; set({ pole: p, artVer: S.artVer + 1 }); }
  function setQty(n) { n = Math.max(1, Math.min(MAX_QTY, Math.round(Number(n)) || 1)); if (n !== S.qty) set({ qty: n }); else render(); }
  // the back of a double-sided flag: the same art as the front, or its own
  function pickBackMode(mode) {
    if (mode === S.backMode) return;
    var patch = { backMode: mode, artVer: S.artVer + 1 };
    if (mode === 'different') { patch.face = 'back'; patch.back = true; } // go straight to the back so its art can be added
    else { patch.face = 'front'; patch.back = false; }
    set(patch);
    view3d(S.back ? 'back' : 'front');
  }

  // ---------- artwork ----------
  function artFor(face) {
    if (face === 'back' || face === 'back-flat') {
      var c = cfg();
      if (c.sides === 2 && S.backMode === 'different') return ART.back;
      return ART.front;
    }
    return ART.front;
  }
  // v2: text, clipart and logo layers added in the builder (ardor-flag-layers.js). Same face rule as artFor.
  function layerFace(face) { return (face === 'back' || face === 'back-flat') && cfg().sides === 2 && S.backMode === 'different' ? 'back' : 'front'; }
  function hasLayers(f) { return !!(window.ArdorFlagLayers && window.ArdorFlagLayers.has(f)); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // v2 (Oct 12, 2026): the cart refuses any add-to-cart request over 20 MB ("413 Request Entity Too Large"), and the
  // request holds the proof, the print file(s) and the customer's original upload(s). Keep the whole upload under
  // UPLOAD_BUDGET: print files first (made smaller when needed), then the proof, then the original files while they fit.
  // Same approach as assets/ardor-aframe-builder-v2-v2.js.
  var UPLOAD_BUDGET = 18 * 1024 * 1024;
  function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function decodeBlob(file) {
    if (window.createImageBitmap) return createImageBitmap(file);
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
      im.src = u;
    });
  }
  // re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
  function shrinkImage(file, maxBytes) {
    if (!file || file.size <= maxBytes) return Promise.resolve(file);
    return decodeBlob(file).then(function (bmp) {
      var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
      var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
      var attempt = function () {
        var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        if (!ctx) return Promise.reject(new Error('canvas'));
        ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bmp, 0, 0, w, h);
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
          cv.width = cv.height = 1;
          if (!b) throw new Error('could not make the print image');
          if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
          if (bmp.close) bmp.close();
          return new File([b], String(file.name || 'Ardor Flag Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
        });
      };
      return attempt();
    });
  }
  // the print file for one face again, as one flattened image of at most maxBytes (same path as faces with text or clipart)
  function smallerPrint(c, face, a, maxBytes, approval) {
    var P = window.ArdorFlagPDF, LY = window.ArdorFlagLayers, Wi = c.Wi, Hi = c.Hi;
    if (!P || !P.buildPrint || !LY || !LY.composite) return Promise.reject(new Error('print tools not loaded'));
    var stamp = (approval && approval.when) || stampLabel(new Date());
    return LY.composite(face, Wi, Hi, a).then(function (r) { return shrinkImage(r.file, maxBytes - 65536); }).then(function (file) {
      return P.buildPrint({ title: 'Ardor Flag Print File', stamp: stamp, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125,
        faces: [{ art: { file: file, name: file.name, kind: 'image', bg: '#FFFFFF' }, bg: '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: Wi, h: Hi }; } }] }, false);
    }).then(function (r) { return r && r.blob; });
  }
  function fitUpload(c, files, approval) {
    var backDiff = c.sides === 2 && S.backMode === 'different';
    var faces = backDiff ? ['front', 'back'] : ['front'];
    var size = function (b) { return b ? b.size : 0; };
    files.skipArt = { front: false, back: false }; files.needEmail = false;
    var orig = function (f) { return ART[f] && ART[f].file ? ART[f].file : null; };
    var prints = function () { return faces.reduce(function (t, f) { return t + size(files[f]); }, 0); };
    var total = function () { return size(files.proof) + prints() + faces.reduce(function (t, f) { return t + (files.skipArt[f] ? 0 : size(orig(f))); }, 0); };
    if (total() <= UPLOAD_BUDGET) return Promise.resolve(files);
    // 1. each print file gets an equal share of what the proof leaves
    var share = Math.max(1572864, Math.floor((UPLOAD_BUDGET - size(files.proof) - 262144) / faces.length));
    var chain = Promise.resolve();
    faces.forEach(function (f) {
      chain = chain.then(function () {
        var bl = files[f]; if (!bl || bl.size <= share) return null;
        return smallerPrint(c, f, ART[f], share, approval).then(function (nb) {
          if (nb && nb.size < bl.size) {
            files[f] = nb;
            files.notes.push('The ' + f + ' print file was made at a lower resolution (' + fmtMB(bl.size) + ' to ' + fmtMB(nb.size) + ') to fit the 20 MB online order upload limit.');
          }
        }, function () { return null; });
      });
    });
    return chain.then(function () {
      // 2. the customer's original files, while they still fit
      var used = size(files.proof) + prints();
      faces.forEach(function (f) {
        var o = orig(f); if (!o) return;
        if (used + o.size <= UPLOAD_BUDGET) { used += o.size; return; }
        files.skipArt[f] = true;
        if (!files[f]) files.needEmail = true;
        files.notes.push('The customer\'s original ' + f + ' file (' + (ART[f].name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files[f] ? ' The print file has the full design.' : ' The customer was asked to email it.'));
      });
      // 3. last resort: a print file that could not be made small enough stays out
      ['back', 'front'].forEach(function (f) {
        if (total() <= UPLOAD_BUDGET || !files[f]) return;
        files.notes.push('The ' + f + ' print file (' + fmtMB(files[f].size) + ') was too large to attach. Make it from the original artwork.');
        files[f] = null;
        if (files.skipArt[f] || !orig(f)) files.needEmail = true;
      });
      return files;
    });
  }
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (!hasLayers(f)) return Promise.resolve(mkJob(a));
    return window.ArdorFlagLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorFlagLayers; if (!LY || !LY.list) return '';
    var keys = c.sides === 2 && S.backMode === 'different' ? ['front', 'back'] : ['front'];
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? (k === 'front' ? 'Front: ' : 'Back: ') : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  // art turned 90 or 270 degrees: its box is as wide as the picture is tall
  function rot90(a) { return !!a && (a.rot === 90 || a.rot === 270); }
  function geom(a, Wi, Hi) {
    var ia = rot90(a) ? a.natH / a.natW : a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW, rot: a.rot || 0 };
  }
  // draw a picture into its placed box g (the box of the art as turned), turned g.rot degrees clockwise
  function drawRot(ctx, img, g) {
    if (!g.rot) { ctx.drawImage(img, g.x, g.y, g.w, g.h); return; }
    var q = g.rot === 90 || g.rot === 270, dw = q ? g.h : g.w, dh = q ? g.w : g.h;
    ctx.save();
    ctx.translate(g.x + g.w / 2, g.y + g.h / 2);
    ctx.rotate(g.rot * Math.PI / 180);
    ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorFlagLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      drawRot(ctx, a.img, g);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorFlagLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  // Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
  // as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
  // attached to the order.
  var ROT_NOTE = 'A photo carried a camera rotation tag, so the print file uses an upright copy of it.';
  function jpegOrientation(file) {
    return file.slice(0, 262144).arrayBuffer().then(function (ab) {
      var v = new DataView(ab), n = v.byteLength, p = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
      while (p + 4 <= n) {
        var m = v.getUint16(p);
        if ((m & 0xFF00) !== 0xFF00) return 1;
        if (m === 0xFFDA || m === 0xFFD9) return 1;
        var len = v.getUint16(p + 2);
        if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
          var t = p + 10, le = v.getUint16(t) === 0x4949;
          var ifd = t + v.getUint32(t + 4, le);
          if (ifd + 2 > n) return 1;
          var cnt = v.getUint16(ifd, le);
          for (var i = 0; i < cnt; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 12 > n) return 1;
            if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
          }
          return 1;
        }
        p += 2 + len;
      }
      return 1;
    }).catch(function () { return 1; });
  }
  function fixOrientation(a) {
    if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
    a.ready = jpegOrientation(a.file).then(function (o) {
      if (!(o >= 2 && o <= 8) || !a.img) return null;
      var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
      cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
      return new Promise(function (res) {
        cv.toBlob(function (b) {
          if (b) { a.printFile = new File([b], 'Ardor Flag Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
          cv.width = cv.height = 1; res(null);
        }, 'image/jpeg', 0.95);
      });
    }).catch(function () {});
  }

  // A file added while the Back tab shows "Same on both sides" is art for the back, so the sign switches to "Different back".
  function uploadFace(file) {
    if (S.face !== 'back') return 'front';
    if (file && file.size <= MAX_FILE && cfg().sides === 2 && S.backMode !== 'different') {
      S.backMode = 'different'; S.back = true; S.artVer++;
      toast('This art goes on the back. The front keeps its own art.');
    }
    return 'back';
  }

  // v2: a finished template file (made on the template page of this face, so it has the page's shape within TPL_TOL)
  // is placed edge to edge on the whole page, bleed included, unturned
  var TPL_TOL = 0.01;
  function tplFit(a, face) {
    var c = cfg();
    if (!a || !a.img || !(a.natW > 0) || !(a.natH > 0) || !(c.Wi > 0) || !(c.Hi > 0)) return false;
    if (Math.abs((a.natW / a.natH) / (c.Wi / c.Hi) - 1) > TPL_TOL) return false;
    a.mode = 'fill'; a.rot = 0; a.rcx = 0.5; a.rcy = 0.5; a.tpl = true;
    toast('Template file detected - placed edge to edge');
    return true;
  }
  function loadFile(file, face) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF', rot: 0 };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500; fixOrientation(a);
      ART[face] = a; tplFit(a, face); S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (ART.front === a || ART.back === a) { tplFit(a, ART.front === a ? 'front' : 'back'); S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your flag, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your flag.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your flag.' + tail;
  }
  function needsEmailProof() {
    var c = cfg(), used = [ART.front]; if (c.sides === 2 && S.backMode === 'different') used.push(ART.back);
    return used.some(function (x) { return x && x.noPreview; });
  }

  // ---------- flat flag drawing (2D editor, 3D faces and proof) ----------
  function polyPath(ctx, p) { if (!p || !p.length) return; ctx.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) ctx.lineTo(p[i][0], p[i][1]); ctx.closePath(); }
  var checkerCv = null;
  function checker(ctx, u) {
    try {
      if (!checkerCv) {
        checkerCv = document.createElement('canvas'); checkerCv.width = checkerCv.height = 16;
        var x = checkerCv.getContext('2d'); x.fillStyle = '#ECECEF'; x.fillRect(0, 0, 16, 16); x.fillStyle = '#DADADF'; x.fillRect(0, 0, 8, 8); x.fillRect(8, 8, 8, 8);
      }
      var pat = ctx.createPattern(checkerCv, 'repeat');
      if (pat && pat.setTransform && window.DOMMatrix) { pat.setTransform(new DOMMatrix().scale(u * 0.75)); return pat; }
    } catch (e) {}
    return '#E6E6EA';
  }
  // the guides on one face: outside the cut line dimmed (it is cut off), the pole sleeve shaded and labelled, the cut
  // line, and the dashed red safe line. u = inches per screen pixel (line widths).
  function drawGuides(ctx, c, Wi, Hi, face, u) {
    var G = faceGeo(c, face);
    ctx.save();
    ctx.setLineDash([]);
    ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); polyPath(ctx, G.cut);
    ctx.globalAlpha = 0.86; ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd'); ctx.globalAlpha = 1;
    if (G.sleeve.length) {
      // the black pole sleeve: sewn on along the pole edge, outside the printed area (inside it when the template marks it there)
      ctx.save();
      if (G.run) {
        // a band just outside the cut line along the sleeve's edges: a wide stroke with its inner half clipped away
        ctx.beginPath(); ctx.rect(-1000, -1000, Wi + 2000, Hi + 2000); polyPath(ctx, G.cut); ctx.clip('evenodd');
        ctx.beginPath(); ctx.moveTo(G.run[0][0], G.run[0][1]);
        for (var ri = 1; ri < G.run.length; ri++) ctx.lineTo(G.run[ri][0], G.run[ri][1]);
        ctx.lineJoin = 'round'; ctx.lineCap = 'butt'; ctx.lineWidth = 2 * G.sleeveW; ctx.strokeStyle = 'rgba(22,22,27,0.88)'; ctx.stroke();
      } else {
        if (!G.sleeveOut) { ctx.beginPath(); polyPath(ctx, G.cut); ctx.clip(); }
        ctx.fillStyle = G.sleeveOut ? 'rgba(22,22,27,0.88)' : 'rgba(22,22,27,0.34)';
        G.sleeve.forEach(function (p) { ctx.beginPath(); polyPath(ctx, p); ctx.fill(); });
      }
      ctx.restore();
      var sb = bbox([].concat.apply([], G.sleeve)), tall = sb.h >= sb.w, thick = tall ? sb.w : sb.h;
      if (thick / u >= 9) {
        var fs = Math.min(thick * 0.62, 1.6);
        ctx.save();
        ctx.translate(sb.x + sb.w / 2, sb.y + sb.h / 2);
        if (tall) ctx.rotate(-Math.PI / 2);
        ctx.font = '600 ' + fs + 'px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(255,255,255,0.92)';
        ctx.fillText('POLE SLEEVE', 0, 0);
        ctx.restore();
      }
    }
    ctx.beginPath(); polyPath(ctx, G.cut);
    ctx.lineWidth = u * 1.4; ctx.strokeStyle = 'rgba(12,13,13,0.9)'; ctx.stroke();
    G.safe.forEach(function (p) {
      ctx.beginPath(); polyPath(ctx, p);
      ctx.setLineDash([]); ctx.lineWidth = u * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)'; ctx.stroke();
      ctx.setLineDash([u * 6, u * 4]); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)'; ctx.stroke();
    });
    ctx.setLineDash([]);
    ctx.restore();
  }
  function drawFlat(ctx, c, Wi, Hi, face, guides, u) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, face), tall = G.bh > G.bw * 1.6;
      ctx.save();
      ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2);
      if (tall) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork goes here', 0, 0);
      ctx.restore();
    }
    if (!guides) return;
    drawGuides(ctx, c, Wi, Hi, face, u || Math.max(Wi, Hi) / 600);
  }

  // ---------- flat layout editor: the whole flag fits the stage; zoom in and pan to work on part of a tall flag ----------
  // lay.scale = screen px per inch, lay.ox / lay.oy = where the page's top-left corner sits on the canvas (css px),
  // lay.zoom 1 = whole flag, lay.cx / lay.cy = the view's center in page fractions when zoomed in.
  var lay = { canvas: null, scale: 1, drag: false, pan: false, hand: false, lx: 0, ly: 0, zoom: 1, cx: 0.5, cy: 0.5, ox: 0, oy: 0 };
  var ZMAX = 8;
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 520;
    var fit = Math.min(maxW / Wi, maxH / Hi), z = fit * lay.zoom;
    var cssW = Math.max(1, Math.round(Math.min(Wi * z, maxW))), cssH = Math.max(1, Math.round(Math.min(Hi * z, maxH)));
    var hx = cssW / (2 * z * Wi), hy = cssH / (2 * z * Hi);
    lay.cx = hx >= 0.5 ? 0.5 : clamp(lay.cx, hx, 1 - hx);
    lay.cy = hy >= 0.5 ? 0.5 : clamp(lay.cy, hy, 1 - hy);
    lay.ox = cssW / 2 - lay.cx * Wi * z; lay.oy = cssH / 2 - lay.cy * Hi * z;
    lay.scale = z; lay.fit = fit;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    var kx = cv.width / cssW, ky = cv.height / cssH;
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z * kx, 0, 0, z * ky, lay.ox * kx, lay.oy * ky);
    drawFlat(ctx, c, Wi, Hi, S.face === 'back' ? 'back-flat' : 'front', true, 1 / z);
    syncZoomUi();
    try { root.dispatchEvent(new CustomEvent('ardor:flag-view')); } catch (e) {}
  }
  function syncZoomUi() {
    var out = $('[data-abb-zoom2d-val]'); if (out) out.textContent = Math.round(lay.zoom * 100) + '%';
    var zi = $('[data-abb-zoom2d-in]'), zo = $('[data-abb-zoom2d-out]'), zf = $('[data-abb-zoom2d-fit]'), hb = $('[data-abb-hand]');
    var zoomed = lay.zoom > 1.001;
    if (!zoomed) lay.hand = false;
    if (zi) zi.disabled = lay.zoom >= ZMAX - 0.001;
    if (zo) zo.disabled = !zoomed;
    if (zf) zf.disabled = !zoomed;
    if (hb) { hb.hidden = !zoomed; hb.setAttribute('aria-pressed', lay.hand ? 'true' : 'false'); }
    if (lay.canvas) lay.canvas.style.cursor = lay.hand ? 'grab' : '';
    root.classList.toggle('abb--hand', !!lay.hand);
  }
  // zoom to z (1 = whole flag); (px, py) = the canvas point (css px) that stays put, else the view's center
  function setZoom(z, px, py) {
    var c = cfg(), Z = clamp(z, 1, ZMAX);
    if (px != null && lay.scale > 0) {
      var ux = (px - lay.ox) / lay.scale / c.Wi, uy = (py - lay.oy) / lay.scale / c.Hi, z1 = lay.fit * Z;
      var cw = lay.canvas ? parseFloat(lay.canvas.style.width) || 0 : 0, ch = lay.canvas ? parseFloat(lay.canvas.style.height) || 0 : 0;
      lay.cx = ux + (cw / 2 - px) / (z1 * c.Wi); lay.cy = uy + (ch / 2 - py) / (z1 * c.Hi);
    }
    lay.zoom = Z;
    drawLayout();
  }
  function panBy(dx, dy) { var c = cfg(); lay.cx -= dx / (lay.scale * c.Wi); lay.cy -= dy / (lay.scale * c.Hi); drawLayout(); }
  // turn the art on the face being edited 90 degrees (d = 90 right, -90 left) around its center, keeping its size
  function rotateArt(d) {
    var a = editingArt(); if (!a || !a.img) return;
    var c = cfg(), g = geom(a, c.Wi, c.Hi);
    a.rot = (((a.rot || 0) + d) % 360 + 360) % 360;
    if (a.mode === 'custom') a.rw = g.h / c.Wi;
    S.artVer++; render();
  }

  function editingArt() { return S.face === 'back' ? (S.backMode === 'different' ? ART.back : null) : ART.front; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    // drag the art to move it. Zoomed in: drag outside the art (or with the hand tool on) to move the view.
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(), c = cfg(), zoomed = lay.zoom > 1.001, onArt = false;
      if (a && a.img && !lay.hand) {
        if (!zoomed) onArt = true;
        else {
          var g = geom(a, c.Wi, c.Hi), r = cv.getBoundingClientRect();
          var ux = (e.clientX - r.left - lay.ox) / lay.scale, uy = (e.clientY - r.top - lay.oy) / lay.scale;
          onArt = ux >= g.x && ux <= g.x + g.w && uy >= g.y && uy <= g.y + g.h;
        }
      }
      if (!onArt && !zoomed) return;
      lay.drag = onArt; lay.pan = !onArt; lay.lx = e.clientX; lay.ly = e.clientY;
      if (lay.pan) cv.style.cursor = 'grabbing';
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (lay.pan) { var px = e.clientX - lay.lx, py = e.clientY - lay.ly; lay.lx = e.clientX; lay.ly = e.clientY; panBy(px, py); return; }
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { var was = lay.pan; lay.drag = false; lay.pan = false; if (was) syncZoomUi(); };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    // mouse wheel / trackpad over the stage: pinch or Ctrl + wheel zooms, the wheel moves the view when zoomed in
    cv.parentNode.addEventListener('wheel', function (e) {
      var r = cv.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top;
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); setZoom(lay.zoom * Math.pow(0.996, e.deltaY), px, py); return; }
      if (lay.zoom <= 1.001) return;
      e.preventDefault();
      panBy(-(e.shiftKey ? e.deltaY : e.deltaX), -(e.shiftKey ? 0 : e.deltaY));
    }, { passive: false });
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    on('[data-abb-rot-l]', 'click', function () { rotateArt(-90); });
    on('[data-abb-rot-r]', 'click', function () { rotateArt(90); });
    on('[data-abb-zoom2d-in]', 'click', function () { setZoom(lay.zoom * 1.5); });
    on('[data-abb-zoom2d-out]', 'click', function () { setZoom(lay.zoom / 1.5); });
    on('[data-abb-zoom2d-fit]', 'click', function () { lay.cx = 0.5; lay.cy = 0.5; setZoom(1); });
    on('[data-abb-hand]', 'click', function () { lay.hand = !lay.hand; syncZoomUi(); });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber)
  function resIssue(a, c) {
    if (!a || !a.img || a.kind !== 'image' || /svg/i.test(a.file.type || a.name)) return null;
    var g = geom(a, c.Wi, c.Hi), ppi = Math.round(a.natW / (rot90(a) ? g.h : g.w));
    if (ppi < 40) return { level: 'bad', text: ' is only about ' + ppi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or pick a smaller flag.' };
    if (ppi < 75) return { level: 'soft', text: ' is about ' + ppi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.' };
    return null;
  }

  function updateArtUi() {
    var c = cfg();
    var two = c.sides === 2, backDiff = two && S.backMode === 'different';
    if (!two && S.face === 'back') { S.face = 'front'; S.back = false; }
    var a = editingArt();
    $('[data-abb-art-tabs]').hidden = !two;
    $$('[data-abb-face]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var sameBack = S.face === 'back' && !backDiff;
    $('[data-abb-drop]').hidden = sameBack;
    var upl = $('[data-abb-upload-label]'); if (upl) upl.textContent = S.face === 'back' ? 'Upload art for the back' : 'Upload artwork';
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var msg = '', level = '';
    if (sameBack) { empty.hidden = false; empty.textContent = 'The back shows the same art as the front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the flag will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.face === 'back' ? 'No art for the back yet. Upload it above.' : 'No artwork yet. Upload yours above.'; }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
    }
    // image resolution on every printed side; the worse one is shown, in the footer, where it is always in view
    var rf = resIssue(ART.front, c), rb = backDiff ? resIssue(ART.back, c) : null;
    var worst = rf && rb ? (rb.level === 'bad' && rf.level !== 'bad' ? 'back' : 'front') : (rf ? 'front' : (rb ? 'back' : ''));
    if (worst) {
      var r = worst === 'back' ? rb : rf;
      msg = (backDiff ? (worst === 'back' ? 'The image for the back' : 'The image for the front') : 'This image') + r.text; level = r.level;
    }
    [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el) {
      if (!el) return;
      el.hidden = !msg; el.textContent = msg;
      if (msg && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
    });
  }

  // ---------- render ----------
  function specLines(c) {
    var out = [['Flag', flagLabel(c)], ['Size', sizeLabel(c)], ['Sides', sidesLabel(c)]];
    if (c.sides === 1 && c.poleOk) out.push(['Pole side', poleLabel(c)]);
    out.push(['Pole & base', kitLabel(c)]);
    if (c.bagV) out.push(['Carry bag', bagLabel(c)]);
    out.push(['Quantity', qtyLabel(c.qty)], ['Delivery', deliveryLabel(c)]);
    return out;
  }

  function sidesNote(c) {
    return c.sides === 2 ? 'Two printed faces sewn together with a block-out layer between them, so each side shows its own art and nothing shows through.'
      : 'Printed through the fabric: the back shows the design in reverse, a little lighter.';
  }
  // small flag silhouettes for the shape cards (24 x 40, pole on the left)
  var SIL = {
    'feather-angled': 'M5 2 L19 7 Q20.5 7.6 20.2 9.4 L17.6 33 Q17.3 35 15.4 35 L5 35 Z',
    'feather-convex': 'M5 2 Q19.5 2.5 20.4 11 L17.8 33 Q17.5 35 15.6 35 L5 35 Z',
    'teardrop': 'M5 3 Q21 3 21 16 Q21 26 5 35 Z',
    'rectangle': 'M5 2 L19 2 L19 33 L5 33 Z',
    'pole-flag': 'M5 8 L22 8 L22 21 L5 21 Z'
  };
  function shapeIcon(shape) {
    return '<svg class="abb-opt__sil" viewBox="0 0 24 40" width="22" height="36" aria-hidden="true" focusable="false"><path d="M3.6 1v38" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="' + (SIL[shape] || SIL.rectangle) + '" fill="currentColor" opacity=".85"/></svg>';
  }

  function render() {
    var c = cfg();
    var p = price(c);
    var fl = flagsShown();

    // 1. flag shape: one card per shape with its silhouette and its lowest price
    fill($('[data-abb-shapes]'), groupsShown().map(function (g) {
      var lo = groupFrom(g.id);
      var html = shapeIcon(g.shape) + '<span class="abb-opt__name">' + esc(g.name) + '</span><span class="abb-opt__price">' + (lo > 0 ? 'from ' + money(lo / 100) : 'Call us') + '</span>';
      return optBtn({ on: g.id === c.flag.group, html: html, data: ['shape', g.id], pick: function () { pickGroup(g.id); } });
    }));

    // 2. size: the sizes of that shape, priced with the chosen sides and kit
    fill($('[data-abb-sizes]'), fl.filter(function (f) { return f.group === c.flag.group; }).map(function (f) {
      var d = kitsFor(f.key, c.sides).length ? c.sides : (c.sides === 2 ? 1 : 2);
      var v = variantFor(f.key, d, kitPick(f.key, d, c.kit)), cents = v.cents > 0 ? v.cents : fromCents(f.key);
      var html = '<span class="abb-opt__name">' + esc(sizeName(f)) + '</span><span class="abb-opt__sub">' + esc(sizeSub(f, geoFor(f.key, 'ss'))) + '</span><span class="abb-opt__price">' + (cents > 0 ? money(cents / 100) : 'Call us') + '</span>';
      return optBtn({ on: f.key === c.key, html: html, data: ['flag', f.key], disabled: !(cents > 0), pick: function () { pickFlag(f.key); } });
    }));

    // 3. sides: printed through (1 side, with the pole side) or two printed faces (2 sides, with the back's art)
    fill($('[data-abb-sides]'), [
      optBtn({ on: c.sides === 1, data: ['sides', 1], disabled: !kitsFor(c.key, 1).length, html: '<span class="abb-opt__name">1 side</span><span class="abb-opt__sub">Printed through, reads in reverse on the back</span>', pick: function () { pickSides(1); } }),
      optBtn({ on: c.sides === 2, data: ['sides', 2], disabled: !kitsFor(c.key, 2).length, html: '<span class="abb-opt__name">2 sides</span><span class="abb-opt__sub">Two printed faces with a block-out layer</span>', pick: function () { pickSides(2); } })
    ]);
    setText('[data-abb-sides-note]', sidesNote(c));
    var poWrap = $('[data-abb-pole-wrap]'); if (poWrap) poWrap.hidden = c.sides !== 1 || !c.poleOk;
    fill($('[data-abb-poles]'), [
      optBtn({ chip: true, on: c.pole === 'left', data: ['pole', 'left'], label: 'Left', pick: function () { pickPole('left'); } }),
      optBtn({ chip: true, on: c.pole === 'right', data: ['pole', 'right'], label: 'Right', pick: function () { pickPole('right'); } })
    ]);
    var bmWrap = $('[data-abb-backmode-wrap]'); if (bmWrap) bmWrap.hidden = c.sides !== 2;
    fill($('[data-abb-backmodes]'), [
      optBtn({ chip: true, on: S.backMode !== 'different', data: ['backmode', 'same'], label: 'Same on both sides', pick: function () { pickBackMode('same'); } }),
      optBtn({ chip: true, on: S.backMode === 'different', data: ['backmode', 'different'], label: 'Different back', pick: function () { pickBackMode('different'); } })
    ]);

    // 4. pole and base: flag only, or the kits this flag comes with, each with the price of one flag with it
    fill($('[data-abb-kits]'), c.kits.map(function (k) {
      var v = variantFor(c.key, c.sides, k.id);
      var html = '<span class="abb-opt__name">' + esc(k.name) + '</span><span class="abb-opt__sub">' + esc(k.sub) + '</span><span class="abb-opt__price">' + (v.cents > 0 ? money(v.cents / 100) : 'Call us') + '</span>';
      return optBtn({ on: k.id === c.kit, html: html, data: ['kit', k.id], disabled: (LIVE && !v.available) || !(v.cents > 0), pick: function () { set({ kit: k.id }); } });
    }));
    setText('[data-abb-kit-note]', c.kit === 'none' ? 'Flag only: a replacement flag for a pole you already have. Check that your pole matches this flag size.' : 'Price per flag, with its ' + c.kitObj.short + '.');

    // 5. carry bag: only when this flag has one
    var bgWrap = $('[data-abb-bag-wrap]'); if (bgWrap) bgWrap.hidden = !c.bagV;
    fill($('[data-abb-bags]'), c.bagV ? [
      optBtn({ on: !c.bag, data: ['bag', 'no'], html: '<span class="abb-opt__name">No bag</span><span class="abb-opt__sub">' + (c.kit === 'none' ? 'Flag only' : 'Flag and pole kit only') + '</span>', pick: function () { set({ bag: false }); } }),
      optBtn({ on: c.bag, data: ['bag', 'yes'], html: '<span class="abb-opt__name">Add a carry bag</span><span class="abb-opt__sub">+' + money(p.bagEach) + ' each, one per flag</span>', pick: function () { set({ bag: true }); } })
    ] : []);
    setText('[data-abb-bag-note]', (c.bag ? bagCount(c.qty) + ': ' + money(p.bags) + ' (' + money(p.bagEach) + ' each).' : '') + (c.bagV && c.kit === 'square-base' ? (c.bag ? ' ' : '') + 'The bag holds the flag and poles. The square base does not fit in it.' : ''));

    // 6. quantity: 1 to 100 flags
    var qIn = $('[data-abb-qty]'); if (qIn && document.activeElement !== qIn) qIn.value = String(c.qty);
    var qm = $('[data-abb-qty-minus]'), qp = $('[data-abb-qty-plus]'); if (qm) qm.disabled = c.qty <= 1; if (qp) qp.disabled = c.qty >= MAX_QTY;
    setText('[data-abb-qty-note]', c.qty > 1 ? qtyLabel(c.qty) + ' at ' + money(p.each) + ' each: ' + money(p.flags) + '. All flags have the same art.' : money(p.each) + ' per flag. All flags in an order have the same art.');

    // 7. delivery: free shipping or free pickup
    fill($('[data-abb-delivery]'), [
      optBtn({ on: c.delivery === 'ship', data: ['delivery', 'ship'], html: '<span class="abb-opt__name">Ship it to me (free)</span><span class="abb-opt__sub">Free shipping to your address</span>', pick: function () { set({ delivery: 'ship' }); } }),
      optBtn({ on: c.delivery === 'pickup', data: ['delivery', 'pickup'], html: '<span class="abb-opt__name">Pick up at our Snohomish shop (free)</span><span class="abb-opt__sub">' + esc(PICKUP) + '</span>', pick: function () { set({ delivery: 'pickup' }); } })
    ]);

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box: the total, then flags x price and the bags
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2 && !c.bag;
    eachEl.textContent = qtyLabel(c.qty) + ' x ' + money(p.each) + (c.bag ? ' + ' + bagCount(c.qty) + ': ' + money(p.bags) : '');
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var dl = c.delivery === 'pickup' ? 'Free pickup at our Snohomish shop' : 'Free shipping';
    setText('[data-abb-free]', dl + '. You approve your proof before checkout.');
    $$('[data-abb-dnote]').forEach(function (el) { el.textContent = dl; });

    // summary chips, the tip on the stage and the 3D tools
    setText('[data-abb-chip-size]', sizeChip(c));
    setText('[data-abb-chip-mat]', c.sides === 2 ? '2 sides' : (c.poleOk ? '1 side, pole ' + c.pole : '1 side'));
    setText('[data-abb-chip-sides]', qtyLabel(c.qty) + ', ' + (c.kit === 'none' ? 'flag only' : c.kitObj.short));
    setText('[data-abb-tip]', 'Keep text and logos inside the red line.');
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorFlag3D, three.js). Everything else works without it. ----------
  var faceCv = { front: null, back: null }, faceSent = { front: '', back: '' }, engSent = '', syncQueued = false;
  // one face for the 3D view: the flag cut to its graphic box (the cut line's box), drawn as seen from that side
  function paintFaceCanvas(c, face) {
    var G = faceGeo(c, face === 'back' ? 'back-flat' : 'front');
    var k = Math.min(60, 2048 / Math.max(G.bw, G.bh));
    var w = Math.max(2, Math.round(G.bw * k)), h = Math.max(2, Math.round(G.bh * k));
    var cv = faceCv[face] || (faceCv[face] = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    ctx.setTransform(w / G.bw, 0, 0, h / G.bh, -G.bx * w / G.bw, -G.by * h / G.bh);
    drawFlat(ctx, c, c.Wi, c.Hi, face === 'back' ? 'back-flat' : 'front', false);
    return cv;
  }
  function sendFace(face, cv) {
    var key = cv ? cv.width + 'x' + cv.height + '|' + engSent : 'none';
    if (faceSent[face] === key) return;
    faceSent[face] = key;
    eng.setFace(face, cv);
  }
  // the 3D flag gets the front face's own outline as seen from the front (pole right = the reverse template), the
  // same geometry the front picture is drawn with, plus the side its sleeve is on
  function sync3d() {
    if (!eng) { drawPoster(); return; } // FLAG3D
    var c = cfg();
    try {
      var b = faceGeo(c, 'front');
      var key = [c.key, c.sides, c.pole, c.kit, c.bag ? 1 : 0].join('|');
      if (key !== engSent) {
        engSent = key;
        eng.set({ key: c.key, shape: c.flag.shape, w: b.bw, h: b.bh, outline: b.cut.map(function (q) { return [q[0] - b.bx, q[1] - b.by]; }), sleeve: b.side, sides: c.sides, kit: c.kitObj.k3d, bag: c.bag });
      }
      sendFace('front', paintFaceCanvas(c, 'front'));
      sendFace('back', c.sides === 2 && S.backMode === 'different' ? paintFaceCanvas(c, 'back') : null);
      eng.refresh();
    } catch (e) {}
  }
  function sync3dSoon() {
    if (syncQueued) return; // FLAG3D: was (!eng || syncQueued); sync3d() draws the poster until the 3D view runs
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } else pendingView = which; }
  // FLAG3D (Oct 20, 2026): the WebGL 3D view no longer starts while the page loads (it was the page's biggest phone speed cost).
  // Until it starts, the 3D box shows a still, flat picture of the flag (poster, drawn by ArdorFlag3D.poster with a 2D canvas).
  // It starts after the visitor's first touch, scroll, wheel, mouse move or key press (in idle time) or 8 s after load, and at once
  // when something needs it: a click on the 3D box, the 3D button or the 3D tools, and the proof's 3D views (proofViews). Undo:
  // restore assets/ardor-flag-builder-v2-backup-oct20f3.js and assets/ardor-flag3d-backup-oct20f3.js.
  var engTried = false, posterCv = null, posterRO = null, posterSz = '', pendingView = '';
  function drawPoster() {
    if (eng || engTried) return;
    var F = window.ArdorFlag3D, host = $('[data-abb-canvas]');
    if (!F || typeof F.poster !== 'function' || !host) return;
    if (!posterCv) {
      posterCv = document.createElement('canvas'); posterCv.className = 'abb-poster'; posterCv.setAttribute('aria-hidden', 'true');
      posterCv.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;display:block;pointer-events:none';
      try { if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative'; } catch (e) {}
      host.appendChild(posterCv);
      if (typeof ResizeObserver !== 'undefined') { try { posterRO = new ResizeObserver(function () { if (posterCv && host.clientWidth + 'x' + host.clientHeight !== posterSz) drawPoster(); }); posterRO.observe(host); } catch (e) {} }
    }
    posterSz = host.clientWidth + 'x' + host.clientHeight;
    var c = cfg();
    try {
      var b = faceGeo(c, 'front');
      F.poster(posterCv, { key: c.key, shape: c.flag.shape, w: b.bw, h: b.bh, outline: b.cut.map(function (q) { return [q[0] - b.bx, q[1] - b.by]; }), sleeve: b.side, sides: c.sides, kit: c.kitObj.k3d, bag: c.bag }, paintFaceCanvas(c, 'front'), '#ffffff');
    } catch (e) {}
  }
  function dropPoster() {
    var p = posterCv; posterCv = null; if (posterRO) { try { posterRO.disconnect(); } catch (e) {} posterRO = null; }
    if (!p) return;
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    raf(function () { raf(function () { if (p.parentNode) p.parentNode.removeChild(p); }); }); // after the 3D view's first frame
  }
  function defer3D() {
    var fired = false, evs = ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel', 'scroll'];
    var idle = function (f, t) { if (window.requestIdleCallback) requestIdleCallback(function () { f(); }, { timeout: t }); else setTimeout(f, 1); };
    var go = function () { if (fired) return; fired = true; evs.forEach(function (e) { removeEventListener(e, go, true); }); idle(startEngine, 1500); };
    evs.forEach(function (e) { addEventListener(e, go, { capture: true, passive: true }); });
    document.addEventListener('click', function (e) { var t = e.target; if (!engTried && t && t.closest && t.closest('[data-abb-viewer], [data-abx-3d], [data-abx-mode="3d"]')) startEngine(); }, true);
    var later = function () { setTimeout(go, 8e3); };
    if (document.readyState === 'complete') later(); else addEventListener('load', later, { once: true });
  }
  function startEngine() {
    if (engTried) return;
    engTried = true;
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorFlag3D && host) ? window.ArdorFlag3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { dropPoster(); if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
    dropPoster(); // FLAG3D
    if (pendingView) { var pv = pendingView; pendingView = ''; view3d(pv); }
  }

  // ---------- proof sheet and print files ----------
  function proofCanvas(face, overlayOnly) {
    var c = cfg(), Wi = c.Wi, Hi = c.Hi;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var fk = face === 'back' ? 'back-flat' : 'front';
    var drewArt = overlayOnly || paintFace(ctx, Wi, Hi, fk);
    if (overlayOnly && hasLayers(layerFace(fk))) window.ArdorFlagLayers.paint(ctx, Wi, Hi, layerFace(fk));
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, fk);
      ctx.save(); ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2); if (G.bh > G.bw * 1.6) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork', 0, 0); ctx.restore();
    }
    var u = Math.max(Wi, Hi) / long; // inches per canvas pixel
    drawGuides(ctx, c, Wi, Hi, fk, u * 2.4);
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var r = a.rot || 0, ia = rot90(a) ? nh / nw : nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi, rot: r };
      var fw0 = Math.min(Wi, Hi * ia), fh0 = fw0 / ia;
      return { x: (Wi - fw0) / 2, y: (Hi - fh0) / 2, w: fw0, h: fh0, rot: r, note: 'The uploaded PDF is a different shape than the flag, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, rot: r };
  }

  function loadPdfTool() {
    if (window.ArdorFlagPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorFlagPDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    var turn = a.rot === 90 ? ', turned 90 degrees right' : (a.rot === 270 ? ', turned 90 degrees left' : (a.rot === 180 ? ', turned upside down' : ''));
    if (a.mode === 'fill') return (a.tpl ? 'Template file, placed edge to edge (bleed included)' : 'Fill flag (edges may crop)') + turn;
    if (a.mode === 'fit') return 'Fit whole image' + turn + ', background ' + a.bg;
    var g = geom(a, c.Wi, c.Hi);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from the print page top-left' + turn + ', background ' + a.bg;
  }
  function artworkLabel() { return ART.front ? ART.front.name : (hasLayers('front') ? 'Text and clipart added in the builder' : 'None'); }
  function backLabel() { return S.backMode === 'different' ? (ART.back ? ART.back.name : (hasLayers('back') ? 'Text and clipart added in the builder' : 'Different art')) : 'Same as front'; }

  function proofSpecs(c) {
    var out = [['Flag', flagLabel(c)], ['Size', sizeLabel(c)], ['Sides', sidesLabel(c)]];
    if (c.sides === 1 && c.poleOk) out.push(['Pole side', poleLabel(c) + ' (as seen from the front)']);
    out.push(['Pole & base', kitLabel(c)]);
    if (c.bagV) out.push(['Carry bag', bagLabel(c)]);
    out.push(['Quantity', qtyLabel(c.qty)], ['Delivery', deliveryLabel(c)]);
    out.push(['Artwork', artworkLabel()]);
    var pl = placementText(ART.front, c); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', backLabel()]);
    if (c.sides === 2 && S.backMode === 'different') { var pb = placementText(ART.back, c); if (pb) out.push(['Back placement', pb]); }
    var added = layerSummary(c); if (added) out.push(['Added in the builder', added]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
function proofViews(c) {
var out = [];
startEngine(); // FLAG3D: the proof's 3D views start the 3D view if it has not started yet
try { sync3d(); } catch (e) {}
if (!eng || typeof eng.snapshot !== 'function') return out;
[['home', 'From the front'], (c.sides === 2 ? ['back', 'From the back'] : ['side', 'From the side'])].forEach(function (v) {
try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
});
return out;
}
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = c.qty > 1 ? 'flags' : 'flag'; o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
  function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorFlagPDF, Wi = c.Wi, Hi = c.Hi;
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var out = { notes: [], proof: null, front: null, back: null };
      var dimW = fmt(Wi) + ' in', dimH = fmt(Hi) + ' in';
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (!a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      // turned PDF/AI art shows on the proof from its drawn preview (the shared proof sheet places vector art unturned)
      var mkProofFace = function (label, faceKey, a) {
        var va = a && !a.rot ? vectorArt(a) : null;
        return { label: label, canvas: proofCanvas(faceKey, !!va), fallback: va ? proofCanvas(faceKey, false) : null, wIn: Wi, hIn: Hi, wLabel: dimW, hLabel: dimH, underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      var faces = [mkProofFace(frontLabel(c), 'front', ART.front)];
      if (backDiff) faces.push(mkProofFace('Back (as seen from the back)', 'back', ART.back));
      var date = (approval && approval.when) || stampLabel(new Date());
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor Flag Proof', panelTitle: c.qty > 1 ? 'Your flags' : 'Your flag', sideBySide: true,
          legend: 'Black line: cut line. Shaded band: pole sleeve. Dashed red line: keep text and logos inside it. Print page ' + fmt(Wi) + ' x ' + fmt(Hi) + ' in (width x height), bleed included.',
          approval: approval || null, date: date, faces: faces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var arts = [ART.front]; if (backDiff) arts.push(ART.back);
      var printable = function (a, i) { return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(i ? 'back' : 'front'); };
      var printP = Promise.resolve();
      // print files: one PDF per printed face that has its own art, the size of that face's template page
      if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ } else if (!arts.every(printable)) out.notes.push('Print files were not made automatically for this file type. Use the original artwork file.');
      else {
        if (arts.some(function (a) { return a && a.src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        // template page size, art to the page edge (bleed included), no guides. buildPrint takes the size in feet.
        var mkJob = function (a) {
          if (a.rotated && out.notes.indexOf(ROT_NOTE) < 0) out.notes.push(ROT_NOTE);
          return { title: 'Ardor Flag Print File', stamp: date, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125, faces: [{ art: a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a), bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } }] };
        };
        var keep = function (r) { r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); }); return r.blob; };
        printP = layerJob(mkJob, ART.front, 'front', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r) {
          out.front = keep(r);
          if (!backDiff) return null;
          return layerJob(mkJob, ART.back, 'back', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r2) { out.back = keep(r2); });
        }).catch(function (e) { out.front = null; out.back = null; out.notes.push('Print files could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_flag_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_flag_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = [[frontLabel(c), 'front', ART.front]];
      if (backDiff) faces.push(['Back', 'back', ART.back]);
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your flag proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + sizeLabel(c) + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    var PL = window.ArdorProofLater; if (PL && PL.on() && !(window.ArdorArtLink && window.ArdorArtLink.emailChosen(root))) { e.preventDefault(); var plr = PL.approve(root); if (plr) closeApproval(plr); return; } // DSN Oct 25 2026: one approval box now; name + typed signature in the cart, email + phone at checkout
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // Line 1: the flag variant (flag, sides and kit), quantity = the number of flags, everything else as line item properties.
  // Line 2, only with carry bags: the bag for this flag, the same quantity.
  function setupMsg() { return 'Online ordering for this flag is being set up. Call ' + PHONE + ' or request a quote.'; }

  // second cart line: carry bags, one per flag. Tried three times.
  function addBagLine(c) {
    var send = function () {
      return fetch(CONF.cartAddUrl || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: c.bagV.id, quantity: c.qty, properties: { 'For': 'Custom flags' } })
      }).then(function (r) { if (!r.ok) throw new Error('bags'); });
    };
    var again = function () { return new Promise(function (res) { setTimeout(res, 700); }).then(send); };
    return send().catch(again).catch(again);
  }

  var bagFail = false; // the flags are in the cart, but the carry bag line could not be added
  function addToCart() {
    if (bagFail) { window.location.href = CONF.cartUrl || '/cart'; return; }
    showErr('');
    var c = cfg(); var p = price(c);
    if (!p.vid || !c.v.available || (c.bag && !(c.bagV && c.bagV.id))) { showErr(setupMsg()); return; }
    var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; // ART0 Oct 19 2026: artwork by link
    if (!ART.front && !hasLayers('front') && !artLink) {
      if (S.face !== 'front') { S.face = 'front'; S.back = false; render(); }
      showErr('Upload your artwork first.');
      return;
    }
    var backDiff = c.sides === 2 && S.backMode === 'different';
    if (backDiff && !ART.back && !hasLayers('back')) {
      if (S.face !== 'back') { S.face = 'back'; S.back = true; render(); }
      showErr('Upload the art for the back, or choose "Same on both sides".');
      return;
    }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false, proofEmail = ''; // ART0: proofEmail
    var waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof() || !!(artLink && !artLink.loaded); // ART0: a link we couldn't open = emailed proof
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      if (ap && ap.emailProof) { proofEmail = ap.email; emailProof = true; ap = null; } // ART0: "Email me the proof to approve"
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }); // v2: stay under the cart's 20 MB upload limit
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      fd.append('properties[Flag]', flagLabel(c));
      fd.append('properties[Size]', sizeLabel(c));
      fd.append('properties[Sides]', sidesLabel(c));
      if (c.sides === 1 && c.poleOk) fd.append('properties[Pole side]', poleLabel(c));
      fd.append('properties[Pole & base]', kitLabel(c));
      if (c.bagV) fd.append('properties[Carry bag]', c.bag ? 'Yes, ' + bagCount(c.qty) + ' (see the carry bag line in this order)' : 'No');
      fd.append('properties[Quantity]', qtyLabel(c.qty));
      fd.append('properties[Delivery]', c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Ship to me (free)');
      fd.append('properties[Artwork]', artworkLabel());
      if (c.sides === 2) fd.append('properties[Back]', backLabel());
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      fd.append('properties[Designed in]', 'Ardor Flag Designer');
        if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
        if (proofEmail || (artLink && !artLink.loaded)) fd.append('properties[Proof approval]', 'Email - pending'); // ART0
        if (proofEmail) fd.append('properties[Proof email]', proofEmail); // ART0
      var pl = placementText(ART.front, c); if (pl) fd.append('properties[_Art placement]', pl);
      if (backDiff) { var pb = placementText(ART.back, c); if (pb) fd.append('properties[_Back placement]', pb); }
      var added = layerSummary(c); if (added) fd.append('properties[_Added in the builder]', added);
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor Flag Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Flag Proof'));
      else if (files.proof) fd.append('properties[_Ardor Flag Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Flag Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', artLink && !artLink.loaded ? 'Ardor will build the proof from your link and email it to you to approve' : 'We\'ll email you a proof to approve before printing'); // ART0
      if (approval) {
        if (!approval.later) fd.append('properties[Approved by]', approval.name); // DSN: the name comes with the cart signature
        fd.append('properties[Approved on]', approval.when);
        if (!approval.later) fd.append('properties[_Approver email]', approval.email); // DSN: email + phone come from checkout
        if (!approval.later) fd.append('properties[_Approver phone]', approval.phone); else { fd.append('properties[Proof approval]', approval.later); fd.append('properties[_Proof sign]', 'cart'); } // DSN
      }
      var tooBig = false;
      [['front', 'Front'], ['back', 'Back']].forEach(function (k) {
        var bl = files[k[0]]; if (!bl) return;
        if (bl.size <= MAXPDF) fd.append('properties[_Ardor Flag Print File ' + k[1] + ' - ' + labelStamp + ']', pdfFile(bl, 'Ardor Flag Print File ' + k[1]));
        else tooBig = true;
      });
      if (tooBig) files.notes.push('A print file was over 25 MB, so it was not attached. Use the original artwork file.');
      var g = c.geo, tname = (g.tplName || '').replace(/\.pdf$/i, '').replace(/^[\s_-]+|[\s_-]+$/g, '');
      var pnote = ['Flag ' + c.key + ': ' + flagLabel(c) + ', ' + sizeName(c.flag) + ' (' + graphicTxt(g, c.key) + ' graphic). Template: ' + (tname || 'flag template') + ' (' + (c.sides === 2 ? 'double-sided' : (c.pole === 'right' ? 'single-sided print-through reverse, pole sleeve on the right as seen from the front' : 'single-sided print-through, pole sleeve on the left as seen from the front')) + '). Kit: ' + kitLabel(c) + '. Carry bags: ' + (c.bag ? c.qty : 'none') + '. Quantity: ' + c.qty + ' flag' + (c.qty === 1 ? '' : 's') + '. Delivery: ' + (c.delivery === 'pickup' ? 'pickup in Snohomish' : 'ship to the customer (blind ship)') + '.'];
      if (c.sides === 2) pnote.push(backDiff ? 'Different art on the back: use the front file and the back file. The back file is the back as seen from behind the flag (pole sleeve on the right); the double-sided template has the front on its left half and the back on its right half.' : 'Same art on both sides: use the front file for both faces of the double-sided template.');
      if (files.front) pnote.push('Print file' + (files.back ? 's are' : ' is') + ' the template page for one face, ' + fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in, art to the page edge (bleed included), no guides, 100% scale.');
      if (g.placeholder) pnote.push('Check the template: this flag used placeholder geometry.');
      files.notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      var skipArt = files.skipArt || {};
      if (ART.front && !skipArt.front) fd.append('properties[Ardor Flag Artwork - ' + labelStamp + ']', ART.front.file, 'Ardor Flag Artwork ' + fileStamp + ext(ART.front.name));
      if (backDiff && ART.back && !skipArt.back) fd.append('properties[Ardor Flag Artwork Back - ' + labelStamp + ']', ART.back.file, 'Ardor Flag Artwork Back ' + fileStamp + ext(ART.back.name));
      if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
      fd.append('properties[_spec]', JSON.stringify({ v: p.vid, flag: c.key, s: c.sides, pole: c.sides === 1 ? c.pole : '', kit: c.kit, b: c.sides === 2 ? S.backMode : '', n: c.qty, bags: c.bag ? c.qty : 0, each: p.each, bagEach: p.bagEach, total: p.charged, del: c.delivery, page: [c.Wi, c.Hi] }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          if (xhr.status === 413) msg = 'Your files are too big to upload with the order. Please try a smaller file, or request a quote.';
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      if (!c.bag) return null;
      return addBagLine(c).catch(function () { bagFail = true; throw { bag: true }; });
    }).then(function () {
      track('ardor_flag_added_to_cart', { value: p.charged, flag: c.key, sides: c.sides, kit: c.kit, bags: c.bag ? c.qty : 0, quantity: c.qty });
      toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      if (err && err.bag) {
        // the flags went in but the bags did not: do not add the flags a second time
        track('ardor_flag_added_to_cart', { value: p.flags, flag: c.key, sides: c.sides, kit: c.kit, bags: 0, quantity: c.qty });
        btns.forEach(function (b) { b.disabled = false; b.textContent = 'Go to cart'; });
        showErr('Your flags are in your cart, but we could not add the carry bags. Go to your cart to check out, then call ' + PHONE + ' and we will add the bags.');
        return;
      }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    if (ART.front) lines.push('Artwork: ' + ART.front.name + ' (I will send the file)');
    var pl = placementText(ART.front, c); if (pl) lines.push('Placement: ' + pl);
    if (c.sides === 2) lines.push('Back: ' + (S.backMode === 'different' ? (ART.back ? ART.back.name : 'different art') : 'same as front'));
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Online price shown: ' + money(p.charged) + ' (' + qtyLabel(c.qty) + ' x ' + money(p.each) + (c.bag ? ', carry bags ' + money(p.bags) : '') + ')');
    return lines.join('\n');
  }

  function openQuote() {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText();
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'Flags from the Ardor Flag Designer\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "Need more than 100, another size or a custom shape? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, uploadFace(f)); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, uploadFace(f)); });
    $$('[data-abb-face]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.face = b.getAttribute('data-abb-face'); S.back = S.face === 'back';
        render(); view3d(S.back ? 'back' : 'front');
      });
    });
    
    
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_flag_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindFlag();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // quantity box, the "more than 100" quote link and the PDF proof button on the tool rail
  function bindFlag() {
    var q = $('[data-abb-qty]');
    if (q) {
      q.addEventListener('input', function () { var v = parseInt(q.value, 10); if (v > MAX_QTY) { q.value = String(MAX_QTY); openQuote(); } if (v >= 1) setQty(Math.min(MAX_QTY, v)); });
      q.addEventListener('change', function () { setQty(q.value); });
      q.addEventListener('blur', function () { render(); });
    }
    on('[data-abb-qty-minus]', 'click', function () { setQty(cfg().qty - 1); });
    on('[data-abb-qty-plus]', 'click', function () { setQty(cfg().qty + 1); });
  }
  // the shared proof sheet (assets/ardor-proofsheet.js) puts its PDF button on the rail for the builders it knows;
  // the flag designer adds the same button itself and opens the same preview window
  function mountPdf(tries) {
    var PS = window.ArdorProofSheet, B = window.ArdorFlagBuilder, rail = $('.abx-rail');
    if (!PS || typeof PS.preview !== 'function' || !rail || !B || !B.proof) { if ((tries || 0) < 40) setTimeout(function () { mountPdf((tries || 0) + 1); }, 250); return; }
    if (B.proof._btn || $('[data-abb-pdf]', rail)) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg><span>PDF</span>';
    var qb = $('[data-abx-quote]', rail);
    if (qb && qb.nextSibling) rail.insertBefore(btn, qb.nextSibling); else rail.appendChild(btn);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); PS.preview(B.proof); });
    B.proof._btn = btn;
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    defer3D(); // FLAG3D: was startEngine()
    window.ArdorFlagBuilder = {
      state: S, flags: FLAGS, kits: KITS, live: function () { return LIVE; }, cfg: cfg, price: price, render: render, variantFor: variantFor, bagFor: bagFor, geo: faceGeo, viewer: function () { return eng; },
      proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); },
      pickFlag: pickFlag, setZoom: setZoom,
      // v2: names for the template download (assets/ardor-flag-tpl.js)
      tplInfo: function () { var c = cfg(); return { key: c.key, product: flagLabel(c), size: sizeLabel(c), sizeName: sizeName(c.flag), sides: c.sides, sidesText: sidesLabel(c), pole: c.sides === 1 && c.poleOk ? c.pole : '', Wi: c.Wi, Hi: c.Hi }; },
      layout: function () { return { zoom: lay.zoom, scale: lay.scale, ox: lay.ox, oy: lay.oy, cx: lay.cx, cy: lay.cy }; }
    };
    // used by ardor-flag-layers.js (text and clipart layers). Sizes are in inches (c.Wi x c.Hi).
    window.ArdorFlagAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[face === 'back' ? 'back' : 'front']; },
      setArt: function (face, a) { ART[face === 'back' ? 'back' : 'front'] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      editFace: function () { return S.face === 'back' ? (S.backMode === 'different' ? 'back' : null) : 'front'; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; },
      // where the page sits on the 2D layout canvas (zoom and pan): z = css px per inch, ox / oy = page corner in css px
      layoutView: function () { return { z: lay.scale, ox: lay.ox, oy: lay.oy }; },
      // the printable face without the pole sleeve, to the page edge (AI designs are placed to fill it), and that box
      // inside the safe distance (new text and logos go there)
      faceBox: function (face) { var g = faceGeo(cfg(), face === 'back' ? 'back-flat' : 'front'); return { x: g.face[0], y: g.face[1], w: g.face[2] - g.face[0], h: g.face[3] - g.face[1] }; },
      safeBox: function () { var g = faceGeo(cfg(), S.face === 'back' ? 'back-flat' : 'front'), sb = bbox([].concat.apply([], g.safe.length ? g.safe : [g.cut])); return { x: sb.x, y: sb.y, w: Math.max(1, sb.w), h: Math.max(1, sb.h) }; },
      pickFlag: pickFlag, flagKey: function () { return cfg().key; }, flagInfo: function (key) { var f = FLAG_BY[normKey(key)]; return f ? { key: f.key, group: f.group, shape: f.shape, name: groupOf(f.group).name + ', ' + sizeName(f) } : null; },
      flags: function () { return flagsShown().map(function (f) { return f.key; }); }
    };
    window.ArdorFlagBuilder.proof = { noun: 'flags', file: 'Ardor Flag Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:flag-api')); } catch (e) {}
    mountPdf(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
